import { API } from "./API";
import { getApiUrl } from "../utils/platform";

export const getRegisteredEtsyShops = (query) => {
  const queryParams = new URLSearchParams();
  
  // Add pagination parameters
  if (query.currentPage) queryParams.append('page', query.currentPage);
  if (query.itemsPerPage) queryParams.append('limit', query.itemsPerPage);
  
  // Add sorting parameters
  if (query.sortBy) queryParams.append('sortBy', query.sortBy);
  if (query.sortOrder) queryParams.append('sortOrder', query.sortOrder);
  
  // Add search parameters
  if (query.search) queryParams.append('search', query.search);
  if (query.status) queryParams.append('status', query.status);
  if (query.ref_etsy_info_pack_mid) queryParams.append('ref_etsy_info_pack_mid', query.ref_etsy_info_pack_mid);
  if (query.trusted_story_mid) queryParams.append('trusted_story_mid', query.trusted_story_mid);
  if (query.shop_id) queryParams.append('shop_id', query.shop_id);
  if (query.seller1_username) queryParams.append('seller1_username', query.seller1_username);
  if (query.seller2_username) queryParams.append('seller2_username', query.seller2_username);
  
  const queryString = queryParams.toString();
  const url = queryString ? `/get?${queryString}` : '/get';
  
  return API.get(`${getApiUrl()}/api/tkt1-registered-etsy-shop${url}`);
};

export const searchRegisteredEtsyShops = (searchQuery) => {
  const queryParams = new URLSearchParams();
  
  if (searchQuery.search) queryParams.append('search', searchQuery.search);
  if (searchQuery.limit) queryParams.append('limit', searchQuery.limit);
  
  const queryString = queryParams.toString();
  const url = queryString ? `/search?${queryString}` : '/search';
  
  return API.get(`${getApiUrl()}/api/tkt1-registered-etsy-shop${url}`);
};

export const getRegisteredEtsyShopByID = (id) => {
  return API.get(`${getApiUrl()}/api/tkt1-registered-etsy-shop/${id}`);
};

export const getRegisteredEtsyShopByMID = (mid) => {
  return API.get(`${getApiUrl()}/api/tkt1-registered-etsy-shop/mid/${mid}`);
};

export const createRegisteredEtsyShop = (shopData) => {
  return API.post(`${getApiUrl()}/api/tkt1-registered-etsy-shop/`, shopData);
};

export const updateRegisteredEtsyShop = (id, shopData) => {
  return API.put(`${getApiUrl()}/api/tkt1-registered-etsy-shop/${id}`, shopData);
};

export const updateRegisteredEtsyShopByMID = (mid, shopData) => {
  return API.put(`${getApiUrl()}/api/tkt1-registered-etsy-shop/mid/${mid}`, shopData);
};

export const deleteRegisteredEtsyShop = (id) => {
  return API.delete(`${getApiUrl()}/api/tkt1-registered-etsy-shop/${id}`);
};

export const tkt1RegisteredEtsyShopService = {
  getRegisteredEtsyShops,
  searchRegisteredEtsyShops,
  getRegisteredEtsyShopByID,
  getRegisteredEtsyShopByMID,
  createRegisteredEtsyShop,
  updateRegisteredEtsyShop,
  updateRegisteredEtsyShopByMID,
  deleteRegisteredEtsyShop
};

export default tkt1RegisteredEtsyShopService;
